import React from 'react';
import CommandesTable from '../../components/organisms/CommandeTable';
import { BackButton } from 'components/molecules/Buttons/BackButton';
import { useToCommandePages } from '../../hooks/useToCommandePages';

const CommandeEleveDetails = ({ match }) => {
  const [toCommandeSinglePage, toCommandeUpdatePage] = useToCommandePages();

  return (
    <>
      <BackButton text="Retourner sur Ma Classe" />
      <CommandesTable
        isExternalUser={true}
        userID={match.params.id}
        toCommandeSinglePage={toCommandeSinglePage}
        toCommandeUpdatePage={toCommandeUpdatePage}
      />
    </>
  );
};

export default CommandeEleveDetails;
